import firebase from "datastore/database";
import store from "datastore/store";
import { getDocChanges } from "common/firebase";
import { addTables, deleteTables, updateTables } from "actions/sections";

export default function observeTables(businessUid, sectionUid, sectionName) {
  return firebase
    .firestore()
    .collection(`tables/${businessUid}/sections/${sectionUid}/tables`)
    .onSnapshot((tablesSnap) => {
      const updates = getDocChanges(tablesSnap.docChanges());
      if (updates.added.length > 0) {
        store.dispatch(addTables(sectionUid, updates.added));
      }
      if (updates.modified.length > 0) {
        store.dispatch(updateTables(sectionUid, updates.modified));
      }
      if (updates.removed.length > 0) {
        store.dispatch(deleteTables(sectionUid, updates.removed));
      }
      // const tables = tablesSnap.docs.map((tableDoc) => ({
      //   uid: tableDoc.id,
      //   ...tableDoc.data(),
      // }));
      // const data = {
      //   ...section,
      //   tables,
      // };
      // store.dispatch({ type: "UPDATE_SECTION", section: data });
    });
}
